/**
 * Role-code groups the screens use to decide what to offer for editing (the API is the authority on
 * access). R11 #649: the old left rail that lived here is gone — navigation is the platform
 * declaration (L0 entries, Admin groups) and each app's declaration, both from GET /api/apps.
 */

/** Every role seeded for this release. `GovernanceLead` is the `HeadOfIT` alias. */
export const EDITOR_ROLES = ['Admin', 'HeadOfIT', 'GovernanceLead', 'DeptEditor', 'ProductEditor'] as const;
export const ADMIN_ROLES = ['Admin', 'HeadOfIT', 'GovernanceLead'] as const;

/**
 * Features that exist only when their API answers. #214: the transport probe
 * (features/transport/nav-probe.tsx) records whether GET /api/transport/status answers.
 */
export type NavFeature = 'transport';
const enabledFeatures = new Set<NavFeature>();
export function setNavFeature(feature: NavFeature, on: boolean): void {
  if (on) enabledFeatures.add(feature);
  else enabledFeatures.delete(feature);
}
export function navFeatureOn(feature: NavFeature): boolean {
  return enabledFeatures.has(feature);
}
